export default __webpack_public_path__ + "static/media/Wilhelm_Scream.0296cfe4.mp3";